import { useScrollPosition } from 'hooks';

const updateNavScroll = () => {
	let position = useScrollPosition()
		, dashboardNav = document.getElementsByClassName('navbar')[0];

	if (dashboardNav) {
		if (position > 0) {
			dashboardNav.classList.add('scrolled')
		} else {
			dashboardNav.classList.remove('scrolled')
		}
	}
};

const setScrolled = () => {
	let position = useScrollPosition();
	if (position > 0) {
		return true;
	}

	return false;
}

export {
	setScrolled,
	updateNavScroll,
}
